import React from 'react';
import { Redirect } from 'react-router-dom';

import { AppRoute } from '../../constants';
import { clearStorage } from '../../utils';

const LogoutPage = () => {
  clearStorage();

  return <Redirect to={AppRoute.MAIN_PAGE_ROUTE} />;
};

export default LogoutPage;
